import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import CartPanel from './components/CartPanel';
import { AfiliadoProvider, useAfiliado } from './context/AfiliadoContext';
import './App.css';

function AppInner() {
  const { afiliado, vistaAfiliado, setVistaAfiliado, login, logout } = useAfiliado();
  const [searchQuery, setSearchQuery] = useState('');
  const [cartAbierto, setCartAbierto] = useState(false);

  // Carrito con persistencia en localStorage
  const [cartItems, setCartItems] = useState(() => {
    try {
      const guardado = localStorage.getItem('carrito');
      return guardado ? JSON.parse(guardado) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('carrito', JSON.stringify(cartItems));
    } catch {
      // almacenamiento no disponible — el carrito vive solo en memoria
    }
  }, [cartItems]);

  const addToCart = (producto) => {
    setCartItems(prev => {
      const existe = prev.find(item => item.id === producto.id);
      if (existe) {
        return prev.map(item =>
          item.id === producto.id
            ? { ...item, cantidad: item.cantidad + 1 }
            : item
        );
      }
      return [...prev, { ...producto, cantidad: 1 }];
    });
  };

  return (
    <Router>
      <Header
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        cartItems={cartItems}
        onCartClick={() => setCartAbierto(true)}
        afiliado={afiliado}
        vistaAfiliado={vistaAfiliado}
        setVistaAfiliado={setVistaAfiliado}
        login={login}
        logout={logout}
      />

      <CartPanel
        abierto={cartAbierto}
        onCerrar={() => setCartAbierto(false)}
        cartItems={cartItems}
        setCartItems={setCartItems}
        vistaAfiliado={vistaAfiliado}
        afiliado={afiliado}
      />

      <Routes>
        <Route
          path="/"
          element={
            <Home
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              addToCart={addToCart}
              vistaAfiliado={vistaAfiliado}
            />
          }
        />
        <Route
          path="/producto/:id"
          element={<ProductDetail addToCart={addToCart} vistaAfiliado={vistaAfiliado} />}
        />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AfiliadoProvider>
      <AppInner />
    </AfiliadoProvider>
  );
}

export default App;